export const iframes = () => {
    const $ = jQuery;

    const iframes = $('iframe.form-iframe');

    if (iframes.length === 0) {
        return false;
    }
    const script = document.createElement('script');

    script.setAttribute('src', 'https://www.ans.co.uk/wp-content/themes/ans/js/seamless.parent.min.js');

    document.body.appendChild(script);

    script.onload = () => {
        const utm_cookie = { utms: window.getCookie('ans_utms') };

        iframes.each((i, iframe) => {
            const child = window.seamless(iframe);

            if (utm_cookie.utms !== undefined) {
                child.send({
                    utms: utm_cookie.utms
                });
            }
        });
    }
};